<template>
  <div class="mall-cart-order-info">
    <!-- 위임장이 등록된 프로필만 노출 -->
    <template v-if="showDelegation">
      <div class="mall-cart-order-info__delegation">
        <div class="mall-cart-order-info__delegation-box">
          <span class="mall-cart-order-info__title">위임청구 적용</span>
          <MallSwitch :value="delegationApplied" @change="$emit('delegation-change', $event)" />
        </div>
        <span class="mall-cart-order-info__delegation-helper">위임청구를 적용하면 공단 지원금이 반영된 금액으로 계산돼요.</span>
      </div>

      <div class="mall-cart-order-info__divider"></div>

      <MallTextField
        :value="prescriptionDays"
        :label="'처방일수 입력'"
        :required="true"
        :inputmode="'numeric'"
        :placeholder="'처방일수를 입력해 주세요'"
        :helper="prescribedDays ? '처방받은 일수 ' + prescribedDays + '일' : ''"
        @input="$emit('prescription-days-input', $event)"
      />

      <div class="mall-cart-order-info__divider"></div>
    </template>

    <div class="mall-cart-order-info__agree-area">
      <div class="mall-cart-order-info__agree" @click="$emit('agree-change', !agreed)">
        <MallCheckBox :checked="agreed" />
        <span class="mall-cart-order-info__title">주문 정보를 모두 확인했어요.</span>
      </div>
    </div>
  </div>
</template>

<script>
import MallCheckBox from '@/components/new/atoms/MallCheckBox.vue'
import MallSwitch from '@/components/new/atoms/MallSwitch.vue'
import MallTextField from '@/components/new/molecules/MallTextField.vue'

export default {
  name: 'MallCartOrderInfo',
  components: {
    MallCheckBox,
    MallSwitch,
    MallTextField,
  },
  props: {
    // 위임청구 / 처방일수 영역 노출 여부
    showDelegation: {
      type: Boolean,
      default: false,
    },
    delegationApplied: {
      type: Boolean,
      default: false,
    },
    prescriptionDays: {
      type: String,
      default: '',
    },
    // 처방받은 일수
    prescribedDays: {
      type: Number,
      default: null,
    },
    agreed: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style scoped>
.mall-cart-order-info {
  display: flex;
  padding: 32px 16px;
  flex-direction: column;
  gap: 16px;
}

.mall-cart-order-info__delegation {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.mall-cart-order-info__delegation-box {
  display: flex;
  padding: 16px 12px;
  justify-content: space-between;
  align-items: center;
  border-radius: 12px;
  background: #F9FAFB;
}

.mall-cart-order-info__title {
  flex: 1;
  min-width: 0;
  color: var(--color-text-main);
  font-family: Pretendard;
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-semibold);
  line-height: var(--line-height-normal);
}

/* 13px 텍스트는 Figma 렌더링 기준(150% → 20px 반올림)으로 맞춤 */
.mall-cart-order-info__delegation-helper {
  color: #8B95A1;
  font-family: Pretendard;
  font-size: var(--font-size-xs);
  font-weight: var(--font-weight-medium);
  line-height: 20px;
  text-align: center;
}

.mall-cart-order-info__divider {
  height: 1px;
  background: #E5E8EB;
}

.mall-cart-order-info__agree-area {
  padding: 0 4px;
}

.mall-cart-order-info__agree {
  display: flex;
  padding: 16px 8px;
  align-items: center;
  gap: 12px;
  border-radius: 12px;
  background: #F9FAFB;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/new/organisms/MallCartOrderInfo.vue